import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { menuCategories } from '../mockData';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Leaf, Search, ShoppingBag } from 'lucide-react';
import { Input } from '../components/ui/input';
import { FadeIn, StaggerContainer, StaggerItem } from '../components/PageTransition';
import { BengaliDecorativeElement, BengaliDivider } from '../components/BengaliPatterns';
import jb from "../assets/Just Bengali (2).png"
export const MenuPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('Starters');

  const filteredCategories = menuCategories.map(category => ({
    ...category,
    items: category.items.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description.toLowerCase().includes(searchTerm.toLowerCase())
    )
  }));

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative flex items-center justify-center overflow-hidden mt-40 h-[15rem] lg:h-[50rem]  md:h-[30rem]" >
       <img src={jb} alt="Just Bengali" className="absolute inset-0 w-full h-50 " />
      </section>

      {/* Menu Section */}
      <section className="py-20 bg-white relative overflow-hidden ">
        <BengaliDecorativeElement pattern="terracotta" className="absolute inset-0 z-0" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <Tabs defaultValue="Starters" className="w-full">
            <FadeIn>
              <TabsList className="flex flex-wrap justify-center gap-2 mb-12 bg-transparent h-auto">
                {menuCategories.map((category) => (
                  <TabsTrigger
                    key={category.id}
                    value={category.category}
                    onClick={() => setActiveCategory(category.category)}
                    className="px-6 py-3 rounded-lg font-medium transition-all duration-300 data-[state=active]:bg-amber-700 data-[state=active]:text-white bg-amber-100 text-amber-900 hover:bg-amber-200"
                  >
                    {category.category}
                  </TabsTrigger>
                ))}
              </TabsList>
            </FadeIn>

            {filteredCategories.map((category) => (
              <TabsContent key={category.id} value={category.category}>
                <StaggerContainer staggerDelay={0.1}>
                  <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6">
                    {category.items.length > 0 ? (
                      category.items.map((item) => (
                        <StaggerItem key={item.id}>
                          <motion.div
                            whileHover={{ scale: 1.02, y: -5 }}
                            transition={{ duration: 0.3 }}
                          >
                            <Card className="group hover:shadow-xl transition-all duration-300 bg-white border-amber-100 overflow-hidden" style={{height:"536px"}}>

  {/* 🔥 Image Top */}
<div className="w-full h-[350px] overflow-hidden">
  <img
    src={item.image}
    alt={item.name}
    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
  />
</div>

  <CardContent className="p-6">
    <div className="flex justify-between items-start mb-3">
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-2">
          <h3 className="text-xl font-bold text-amber-900 group-hover:text-amber-700 transition-colors duration-300">
            {item.name}
          </h3>

          {item.isVeg && (
            <Badge variant="outline" className="border-green-600 text-green-600 flex items-center gap-1">
              Veg
            </Badge>
          )}
        </div>

       <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
  {item.description}
</p>
      </div>

      <span className="text-2xl font-bold text-amber-700 ml-4">
        {item.price}
      </span>
    </div>

    {/* <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="w-full mt-4 px-4 py-2 bg-amber-100 hover:bg-amber-700 text-amber-900 hover:text-white rounded-lg transition-all duration-300 text-sm font-medium flex items-center justify-center gap-2"
    >
      Add to Order
    </motion.button> */}
  </CardContent>
</Card>
                          </motion.div>
                        </StaggerItem>
                      ))
                    ) : (
                      <div className="col-span-2 text-center py-12">
                        <p className="text-gray-500 text-lg">No dishes found matching your search.</p>
                      </div>
                    )}
                  </div>
                </StaggerContainer>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </section>

      {/* Download Menu CTA */}
      <FadeIn>
        <section className="py-16 bg-amber-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h3 className="text-3xl font-bold text-amber-900 mb-4">
              Want to take our menu home?
            </h3>
            <p className="text-gray-600 mb-6">
              Download our complete menu as a PDF
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-amber-700 hover:bg-amber-800 text-white px-8 py-3 rounded-lg font-medium transition-all duration-300"
            >
              Download Menu (PDF)
            </motion.button>
          </div>
        </section>
      </FadeIn>
    </div>
  );
};

export default MenuPage;
